import getAppState from 'app-state';
import {AppState} from '@reliv/pws-core';

const STATE_KEY = 'pws';

/**
 * Returns whether the current site is a personal website or not
 */
export const isPws = () => !!(getState().isPws);

/**
 * Return whether the current user is the PWS owner of the current site
 */
export const isOwner = () => {
    // tslint:disable-next-line:no-shadowed-variable
    const {isOwner, isPws} = getState();
    return !!(isPws && isOwner);
};

/**
 * Return wether or not we are currently in edit mode
 */
export const isEditing = () => {
    // tslint:disable-next-line:no-shadowed-variable
    const {isEditing, isOwner, isPws} = getState();
    return !!(isPws && isOwner && isEditing);
};

const getState = () => getAppState<AppState>(STATE_KEY, {
    isEditing: false,
    isOwner: false,
    isPws: false,
});
